import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ItemSelectionDropdown from '@/Components/ItemSelectionDropdown/ItemSelectionDropdown';
import LinkedItemBubble from '@/Components/LinkedItems/LinkedItemBubble';
import { useApplication } from '@/Components/ApplicationProvider';
import { ElementIds } from '@/Constants/ElementIDs';
import { createLinkFromItem } from '@/Utils/Items/Search/createLinkFromItem';
import { ContentType, SNTag } from '@standardnotes/snjs';
import { observer } from 'mobx-react-lite';
const SearchTagFilters = ({ searchOptions }) => {
    const application = useApplication();
    const { tagFilterList } = searchOptions;
    const selected = application.navigationController.selected;
    const excludeUuids = tagFilterList.map((tag) => tag.uuid);
    if (selected instanceof SNTag && !excludeUuids.includes(selected.uuid)) {
        excludeUuids.push(selected.uuid);
    }
    return (_jsxs("div", { className: "flex flex-wrap items-center gap-2", children: [tagFilterList.map((tag) => (_jsx(LinkedItemBubble, { className: "m-0", link: createLinkFromItem(tag, 'linked'), unlinkItem: async (item) => {
                    var _a;
                    searchOptions.removeTagFilter(item);
                    (_a = document.getElementById(ElementIds.SearchBar)) === null || _a === void 0 ? void 0 : _a.focus();
                }, isBidirectional: false, inlineFlex: true }, tag.uuid))), _jsx(ItemSelectionDropdown, { onSelection: (item) => searchOptions.addTagFilter(item), placeholder: "Add tag...", contentTypes: [ContentType.TYPES.Tag], excludeUuids: excludeUuids })] }));
};
export default observer(SearchTagFilters);
